import { TransferType } from "../../transfers-other-banks/models/transferType.enum";

export class Limit {
	singleMaxValue: any;
	dailyMaxValue: any;
	timeLimit: string;
	timeStart: string;
	fee: any;
	compensationDate: any;
	typeLimit: string;
	utilDay: boolean;
	transfers: Array<string>;
	tarifs: Array<string>;
	investmenst: Array<string>;
	securities: Array<string>;
	accounts: Array<string>;

	constructor() {

	}
}
export enum LimitTipo {
	TODOS = 'TODOS',
	TEF = 'TEF',
	TED = 'TED',
	DOC = 'DOC',
	PIX = 'PIX',
	CARTAO = 'CARTAO',
	BOLETO = 'BOLETO',
	CONVENIO = 'CONVENIO',
	TRIBUTO_FEDERAL = 'TRIBUTO_FEDERAL',
	INVESTIMENTO = 'INVESTIMENTO',
	REGISTRO_BOLETOS = 'REGISTRO_BOLETOS'
}

export class LimiteGeralModel {
	ValorMaximo?: number;
	TempoEsgotado?: number;
	Tipo?: LimiteTipoPeriodo;
	Valor?: number;
	ValorMaximoPorDia?: number;
	ValorMaximoPorTransacao?: number;
	ValorPorDia?: number;
	ValorPorTransacao?: number;
	DiaUtilHoje?: boolean;
	FaixaHorario?: LimitePixFaixaHorarioModel;
	ValorLimiteRequisitado?: number | null;
	LimitarValorMaximoPorDia?: boolean;
	LimitarValorPorDia?: boolean;

}

export enum LimiteTipoPeriodo {
	TEF_DIURNO = 'TEF_DIURNO',
	TEF_NOTURNO = 'TEF_NOTURNO',
	DOC_DIURNO = 'DOC_DIURNO',
	DOC_NOTURNO = 'DOC_NOTURNO',
	TED_DIURNO = 'TED_DIURNO',
	TED_NOTURNO = 'TED_NOTURNO',
	PIX_DIURNO = 'PIX_DIURNO',
	PIX_NOTURNO = 'PIX_NOTURNO',
	CARTAO_DIURNO = 'CARTAO_DIURNO',
	CARTAO_NOTURNO = 'CARTAO_NOTURNO',
	BOLETO_DIURNO = 'BOLETO_DIURNO',
	BOLETO_NOTURNO = 'BOLETO_NOTURNO',
	CONVENIO_DIURNO = 'CONVENIO_DIURNO',
	CONVENIO_NOTURNO = 'CONVENIO_NOTURNO',
	TRIBUTO_FEDERAL_DIURNO = 'TRIBUTO_FEDERAL_DIURNO',
	TRIBUTO_FEDERAL_NOTURNO = 'TRIBUTO_FEDERAL_NOTURNO',
	INVESTIMENTO_DIURNO = 'INVESTIMENTO_DIURNO',
	INVESTIMENTO_NOTURNO = 'INVESTIMENTO_NOTURNO',
	QRCODE_PIX_SAQUE_TROCO_DIURNO = 'QRCODE_PIX_SAQUE_TROCO_DIURNO',
	QRCODE_PIX_SAQUE_TROCO_NOTURNO = 'QRCODE_PIX_SAQUE_TROCO_NOTURNO',
	DEPOSITO_POR_BOLETO_DIURNO = 'DEPOSITO_POR_BOLETO_DIURNO',
}

export type LimitPeriodType = 'NOTURNO' | 'DIURNO';

export type LimitIdentifierType = {
	limitType: LimitTipo;
	limitPeriod: LimitPeriodType;
};

export type AllPeriodsLimitType = {
	type: LimitTipo | TransferType;
	dailyLimit: LimiteGeralModel;
	nightlyLimit?: LimiteGeralModel;
};

export enum LimitePrazoCompensacao {
	MESMO_DIA_UTIL = 'MESMO_DIA_UTIL',
	PROXIMO_DIA_UTIL = 'PROXIMO_DIA_UTIL',
}

export enum LimiteTipoTransacaoDisponivel {
	AGENDAR_TRANSACOES = 'AGENDAR_TRANSACOES',
	REALIZAR_AGENDAR_TRANSACOES = 'REALIZAR_AGENDAR_TRANSACOES',
}

export class LimitePixFaixaHorarioModel {
	HorarioFinal?: string;
	HorarioInicial?: string;
	PrazoCompensacao?: LimitePrazoCompensacao | number;
	TipoTransacaoDisponivel?: LimiteTipoTransacaoDisponivel;
}

export class PeriodoLimiteModel {
	tipo: LimiteTipoPeriodo;
	janela: string;
	valor: number;
	valorMaximo: number;
	valorLimiteRequisitado: number | null;
	horarioInicial?: string;
	horarioFinal?: string;
}

export class LimiteViewModel {
	nome: string;
	limiteDiurno: PeriodoLimiteModel;
	limiteNoturno: PeriodoLimiteModel;

	constructor(nome: string) {
		this.nome = nome;
		this.limiteDiurno = new PeriodoLimiteModel();
		this.limiteNoturno = new PeriodoLimiteModel();
	}
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/models/limits.ts